// extracted by mini-css-extract-plugin
export default {"wrapper":"DataProt_wrapper__40JYc","container":"DataProt_container__CaD7p"};